import React, { useState } from "react";

const Card = ({ label, active, onClick }) => (
  <div
    onClick={onClick}
    className={`
      cursor-pointer w-40 h-24 rounded-xl border
      flex items-center justify-center text-lg font-semibold
      transition
      ${
        active
          ? "border-[#0A2A4F] bg-[#0A2A4F]/10 text-[#0A2A4F]"
          : "border-gray-200 bg-white text-[#0A2A4F]"
      }
    `}
  >
    {label}
  </div>
);

const UserTypeModal = ({ onConfirm }) => {
  const [selected, setSelected] = useState("");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl p-8 shadow-xl w-[380px]">
        <h3 className="text-center text-xl font-semibold text-[#0A2A4F] mb-6">
          Select User Type
        </h3>

        <div className="flex justify-center gap-6 mb-6">
          <Card
            label="Internal User"
            active={selected === "internal"}
            onClick={() => setSelected("internal")}
          />
          <Card
            label="External User"
            active={selected === "external"}
            onClick={() => setSelected("external")}
          />
        </div>

        <button
          disabled={!selected}
          onClick={() => onConfirm(selected)}
          className="w-full py-2.5 rounded-lg bg-[#0A2A4F] text-white disabled:opacity-50"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default UserTypeModal;
